import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Logout } from 'src/shared/state/auth.action';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
	private store = inject(Store);

	ngOnInit() {
		this.store.dispatch(new Logout());
	}
}
